import * as types from './mutations-type'

const mutations = {
    [types.RAWDATA](state, payload) {
        state.rawdata = payload
    },
    [types.DONE](state, payload) {
        state.done = payload
    },
    [types.PRODUCTRAWDATA](state, payload) {
        state.product_raw_data = payload
    },
    [types.FLASH_TEXT_ORGN](state, payload) {
        state.flash_text_orgn = payload
    },
    [types.SPACEY_ORGN](state, payload) {
        state.spacey_orgn = payload
    },
    [types.STATES](state, payload) {
        state.states = []
        state.states = payload
    },
    [types.EMAILS_ITEM_REFS](state, payload) {
        state.emails_item_refs.push(payload)
    },
    [types.SIDEBAR](state, payload) {
        state.sidebar = payload
    },
    [types.ALLOWED_SECTORS](state, payload) {
        state.allowed_sectors = payload
    },
    [types.CURRENT_ACTIVE_MODULE](state, payload) {
      state.current_active_module = payload
    },
    [types.USER_ID](state, payload) {
        state.user_id = payload
    },
    [types.BIG_LOADING](state, payload) {
        state.big_loading = payload
    },
    [types.DASHBOARD_TYPE](state, payload) {
        state.dashboardType = payload
    },
    // [types.UPDATED_CHECKBOX](state, payload) {
    //     state.update_checkboxed = payload
    // },
}

export default mutations
